import React, { useState } from 'react';
import './MerchantTrialAwarenessPopup.css';
import api from '../../api';
import { useTranslation } from 'react-i18next';

import myStoreIcon from '../../assets/mystore-icon.png';
import sellIcon from '../../assets/sell-icon.png';
import campaignIcon from '../../assets/campaign-icon.png';
import securedIcon from '../../assets/secured-icon.png';

function MerchantTrialAwarenessPopup({
  open,
  onPassed,
  onActivated,
}) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const showError = (msg) => {
    setSuccessMsg('');
    setErrorMsg(msg);

    window.clearTimeout(showError._t);
    showError._t = window.setTimeout(() => setErrorMsg(''), 3200);
  };

  const showSuccess = (msg) => {
    setErrorMsg('');
    setSuccessMsg(msg);

    window.clearTimeout(showSuccess._t);
    showSuccess._t = window.setTimeout(() => setSuccessMsg(''), 3500);
  };

  if (!open) return null;

  const handleActivate = async () => {
    if (loading) return;

    try {
      setLoading(true);
      setErrorMsg('');
      setSuccessMsg('');

      const res = await api.post('/users/redeem-merchant-trial-auto');

      showSuccess(
        res?.data?.message || t('merchant_trial_popup.success_activated')
      );

      setTimeout(() => {
        if (onActivated) {
          onActivated(res?.data || null);
        }
      }, 800);
    } catch (err) {
      console.error('❌ Failed to auto activate merchant trial:', err);

      const msg =
        err?.response?.data?.message ||
        t('merchant_trial_popup.error_activate');

      showError(msg);
    } finally {
      setLoading(false);
    }
  };

  const handlePass = () => {
    if (loading) return;
    if (onPassed) onPassed();
  };

  return (
    <div className="merchant-trial-popup-backdrop">
      <div
        className="merchant-trial-popup-sheet"
        onClick={(e) => e.stopPropagation()}
      >
        {errorMsg && (
          <div className="merchant-trial-popup-banner error">
            {errorMsg}
          </div>
        )}

        {successMsg && (
          <div className="merchant-trial-popup-banner success">
            {successMsg}
          </div>
        )}

        <div className="merchant-trial-popup-bg-shape merchant-trial-popup-bg-shape--top" />
        <div className="merchant-trial-popup-bg-shape merchant-trial-popup-bg-shape--bottom" />

        <div className="merchant-trial-popup-inner">
          <div className="merchant-trial-popup-top">
            <div className="merchant-trial-popup-icons-row">
              <div className="merchant-trial-popup-icon-wrap">
                <img
                  src={myStoreIcon}
                  alt={t('merchant_trial_popup.icons.store')}
                  className="merchant-trial-popup-icon"
                />
              </div>

              <div className="merchant-trial-popup-icon-wrap">
                <img
                  src={sellIcon}
                  alt={t('merchant_trial_popup.icons.sell')}
                  className="merchant-trial-popup-icon"
                />
              </div>

              <div className="merchant-trial-popup-icon-wrap">
                <img
                  src={campaignIcon}
                  alt={t('merchant_trial_popup.icons.campaign')}
                  className="merchant-trial-popup-icon"
                />
              </div>

              <div className="merchant-trial-popup-icon-wrap">
                <img
                  src={securedIcon}
                  alt={t('merchant_trial_popup.icons.secure')}
                  className="merchant-trial-popup-icon"
                />
              </div>
            </div>

            <h2 className="merchant-trial-popup-title">
              {t('merchant_trial_popup.title')}
            </h2>

            <p className="merchant-trial-popup-subtitle">
              {t('merchant_trial_popup.subtitle')}
            </p>
          </div>

          <div className="merchant-trial-popup-middle">
            <div className="merchant-trial-popup-features-card">
              <div className="merchant-trial-popup-features-grid">
                <div className="merchant-trial-popup-feature-item">
                  <span className="merchant-trial-popup-feature-check">✓</span>
                  <span>{t('merchant_trial_popup.features.unlimited_listings')}</span>
                </div>

                <div className="merchant-trial-popup-feature-item">
                  <span className="merchant-trial-popup-feature-check">✓</span>
                  <span>{t('merchant_trial_popup.features.dynamic_pricing')}</span>
                </div>

                <div className="merchant-trial-popup-feature-item">
                  <span className="merchant-trial-popup-feature-check">✓</span>
                  <span>{t('merchant_trial_popup.features.promotions')}</span>
                </div>

                <div className="merchant-trial-popup-feature-item">
                  <span className="merchant-trial-popup-feature-check">✓</span>
                  <span>{t('merchant_trial_popup.features.escrow_orders')}</span>
                </div>

                <div className="merchant-trial-popup-feature-item">
                  <span className="merchant-trial-popup-feature-check">✓</span>
                  <span>{t('merchant_trial_popup.features.verified_storefront')}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="merchant-trial-popup-bottom">
            <button
              type="button"
              className="merchant-trial-popup-primary-btn"
              onClick={handleActivate}
              disabled={loading}
            >
              {loading
                ? t('merchant_trial_popup.activating')
                : t('merchant_trial_popup.activate_button')}
            </button>

            <button
              type="button"
              className="merchant-trial-popup-pass-btn"
              onClick={handlePass}
              disabled={loading}
            >
              {t('merchant_trial_popup.pass_button')}
            </button>

            <div className="merchant-trial-popup-footnote">
              {t('merchant_trial_popup.footnote')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MerchantTrialAwarenessPopup;
